/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AssetClassificationCreation = {
    readonly uuid?: string;
    label: string;
    level: AssetClassificationCreation.level;
}

export namespace AssetClassificationCreation {

    export enum level {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
    }


}
